"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _apiEnv = _interopRequireDefault(require("../../../api/api-env"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _transactableMain = _interopRequireDefault(require("../shared-components/flow-transactable/transactable-main"));
var _apiProfile = require("../../../api/api-profile");
var _SearchField = _interopRequireDefault(require("../shared-components/reduxForms/fields/SearchField/SearchField"));
var _reactIntl = require("react-intl");
var _sharedIntlProviderHOC = _interopRequireDefault(require("../shared-components/hocs/sharedIntlProviderHOC"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var SpaceTypeForm = /*#__PURE__*/function (_Component) {
  _inherits(SpaceTypeForm, _Component);
  function SpaceTypeForm(props) {
    var _this;
    _classCallCheck(this, SpaceTypeForm);
    _this = _callSuper(this, SpaceTypeForm, [props]);
    _this.state = {
      error: false,
      spaceTypes: [],
      value: '',
      isClient: false
    };
    _this.submitAction = _this.submitAction.bind(_assertThisInitialized(_this));
    _this.checkTransactability = _this.checkTransactability.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(SpaceTypeForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var locale = _sharedIntlProviderHOC.default.getLocale();
      this.setState({
        isClient: true
      });
      return _apiEnv.default.getTags(locale, function (response) {
        var spaceTypes = (0, _lodash.get)(response, 'space_type.values');
        var formatTags = (0, _lodash.map)(spaceTypes, function (tag) {
          return {
            label: tag.display_name,
            value: tag.name
          };
        });
        _this2.setState({
          spaceTypes: formatTags
        });
      });
    }
  }, {
    key: "checkTransactability",
    value: function checkTransactability(user, intendedAction) {
      var _this3 = this;
      var accessToken = PSSessions.Cookies('PSAccess');
      if (!user || !accessToken) {
        location.hash = 'a=signup&source=host';
      } else {
        var cancelProcessing = function cancelProcessing() {
          return _this3.setState({
            processing: false
          });
        };
        _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_sharedIntlProviderHOC.default, null, /*#__PURE__*/_react.default.createElement(_transactableMain.default, {
          user: user,
          intendedAction: intendedAction,
          closeBehavior: cancelProcessing,
          headerMargin: "margin-lg-bottom"
        })), document.getElementById('modal-container'));
      }
    }
  }, {
    key: "submitAction",
    value: function submitAction(el, cb) {
      var _this4 = this;
      var accessToken = PSSessions.Cookies('PSAccess');
      var value = this.state.value;
      if (!value) {
        return this.setState({
          error: true
        });
      }
      window.PSSessions.Cookies.set('aas_type', value);
      if (accessToken) {
        return _apiProfile.Profile.read('/v1/profiles/me', accessToken, function (user) {
          return _this4.checkTransactability(user, function () {
            window.location = "/your-space/address";
          });
        });
      }

      // New sign up
      location.href = '#a=signup&source=host';
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      this.setState({
        value: value,
        error: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var inputClassName = (0, _classnames.default)('SpaceTypeHost', {
        error: this.state.error
      });
      // checking for isClient because we want to show a styled input component
      // which is friendly to penthouse and server rendering
      // then switch to a dynamic component when it switches to the client
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "forms.space_type_form.type_of_space",
        defaultMessage: "What type of space do you have?"
      })), this.state.isClient ? /*#__PURE__*/_react.default.createElement(_SearchField.default, {
        inputClassName: inputClassName,
        classNamePrefix: "SpaceTypeHostInput",
        input: {
          value: this.state.value,
          onBlur: function onBlur() {},
          onChange: this.onChange
        },
        components: {
          ClearIndicator: function ClearIndicator() {
            return null;
          }
        },
        meta: {
          error: this.state.error,
          submitFailed: this.state.error
        },
        errorMessage: this.props.intl.formatMessage({
          id: 'forms.space_type_form.search_error',
          defaultMessage: 'Enter a space type to get started'
        }),
        placeholder: this.props.intl.formatMessage({
          id: 'forms.space_type_form.search_placeholder',
          defaultMessage: 'Apartment, Photo Studio, Gallery'
        }),
        isSearchable: true,
        options: this.state.spaceTypes
      }) : /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        className: "form-control ellipsis",
        placeholder: this.props.intl.formatMessage({
          id: 'forms.space_type_form.search_input_placeholder',
          defaultMessage: 'Apartment, Photo Studio, Gallery'
        })
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "margin-lg-top"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary btn-lg btn-block hero form",
        onClick: this.submitAction
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "forms.space_type_form.button_started",
        defaultMessage: "Get Started"
      }))));
    }
  }]);
  return SpaceTypeForm;
}(_react.Component);
;
SpaceTypeForm.propTypes = {
  buttonClass: _propTypes.default.string
};
exports.SpaceTypeForm = (0, _reactIntl.injectIntl)(SpaceTypeForm);